import { render, staticRenderFns } from "./StaticLandingPageEdit.vue?vue&type=template&id=002186cb&scoped=true&"
import script from "./StaticLandingPageEdit.vue?vue&type=script&lang=js&"
export * from "./StaticLandingPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./StaticLandingPageEdit.vue?vue&type=style&index=0&id=002186cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002186cb",
  null
  
)

export default component.exports